//
//
//
//

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      io: null
    }
  },
  mounted () {
    this.io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !this.disabled) {
          this.$emit('intersecting')
        }
      },
      {
        rootMargin: '120px'
      }
    )

    this.io.observe(this.$refs.el)
  },
  beforeDestroy () {
    if (this.io){
      this.io.unobserve(this.$refs.el)
    }
  }
}
